import { useCallback } from 'react';

type RefCallback<T> = (instance: T | null) => void;
type RefObject<T> = { current: T | null };
type Ref<T> = RefCallback<T> | RefObject<T> | null;

/**
 * Custom hook to merge multiple React refs into one
 * @param refs - Refs to merge
 * @returns - A callback ref that updates all provided refs
 */
export const useMergeRefs = <T>(...refs: Ref<T>[]): RefCallback<T> => {
    return useCallback((instance: T | null) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(instance);
            } else if (ref !== null) {
                (ref as React.MutableRefObject<T | null>).current = instance;
            }
        });
    }, refs); // eslint-disable-line react-hooks/exhaustive-deps
};
